import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
// Import the AF2 Module
import { AngularFireModule } from 'angularfire2';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFireDatabaseModule } from 'angularfire2/database';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { AngularFirestore } from 'angularfire2/firestore';
import { ImportProvider } from '../providers/import/import';
import { AuthProvider } from '../providers/auth/auth';
import { FbServiceProvider } from '../providers/fb-service/fb-service';
import { PipesModule } from '../pipes/pipes.module';
export const firebaseConfig = {
  apiKey: "AIzaSyBSCu7bzmT3DGZ5-KUNlC8q43s-S5B2fxo",
    authDomain: "commandwall.firebaseapp.com",
    databaseURL: "https://commandwall.firebaseio.com",
    projectId: "commandwall",
    storageBucket: "commandwall.appspot.com",
    messagingSenderId: "319393450140"
  };
@NgModule({
  declarations: [
    MyApp,
    HomePage
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp),
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireAuthModule,
    AngularFireDatabaseModule,
    PipesModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    AngularFirestore,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    ImportProvider,
    AuthProvider,
    FbServiceProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts